import { gql } from '@apollo/client';

export const GET_CATEGORIES = gql`
  fragment BaseCategoryFields on Category {
    id
    name
    count
    path
    icon
  }

  query GetCategories(
    $scope: CategoryScopeEnum = DEFAULT
    $orderType: CategoryOrderEnum
    $isDesktop: Boolean = false
    $hasBilingualSearch: Boolean = false
  ) {
    categories(scope: $scope) {
      ...BaseCategoryFields
      description
      propertyOptions {
        name
        count
        legacyResourceId
        parentLegacyId
        propertyLegacyId
      }
      parent {
        isPriceRequired
        ...BaseCategoryFields
      }
      children(orderType: $orderType) {
        id
        name
        azName: name(language: AZ) @include(if: $hasBilingualSearch)
        ruName: name(language: RU) @include(if: $hasBilingualSearch)
        path
        count
        hasAutogeneratedTitle
        isPhotoRequiredOnCreate
        isPriceRequired
        parent {
          ...BaseCategoryFields
        }
        primaryProperty @include(if: $isDesktop) {
          legacyResourceId
          options(isParentArgumentRequired: false) {
            legacyResourceId
            name
          }
        }
      }
    }
  }
`;

export const GET_ROOT_CATEGORIES = gql`
  query GetRootCategories($keywords: String, $filters: AdFilterInput) {
    categories(keywords: $keywords, filters: $filters) {
      id
      name
      path
      icon
    }
  }
`;

export const GET_CATEGORY_PROPERTIES = gql`
  query CategoryProperties(
    $path: String!
    $collectionFilters: [CollectionPropertyOptionInput!]
  ) {
    category(path: $path) {
      id
      properties {
        legacyResourceId
        name
        type
        parentLegacyId
        isRequired
        hint
        measurementUnits
        popularOptions(parentLegacyId: null) {
          legacyResourceId
          name
          propertyLegacyId
          childrenPropertyIds
          photos {
            id
            url
          }
          hasAutogeneratedTitle
        }
        options(parentLegacyId: null, collectionFilters: $collectionFilters) {
          legacyResourceId
          name
          propertyLegacyId
          childrenPropertyIds
          photos {
            id
            url
          }
          hasAutogeneratedTitle
        }
        settings {
          from
          step
          to
        }
        filterOpenByDefault
      }
    }
  }
`;

export const GET_CATEGORY = gql`
  fragment BaseCategoryFields on Category {
    id
    name
    count
    path
    icon
  }

  query Category($path: String!) {
    category(path: $path) {
      id
      name
      h1
      path
      icon
      parent {
        ...BaseCategoryFields
        parent {
          ...BaseCategoryFields
        }
      }
    }
  }
`;

export const GET_CATEGORY_ID = gql`
  query Category($path: String!) {
    category(path: $path) {
      id
    }
  }
`;

export const GET_CATEGORY_DETAILS = gql`
  fragment BaseCategoryFields on Category {
    id
    name
    count
    path
    icon
  }

  query CategoryDetails($path: String!) {
    category(path: $path) {
      id
      name
      path
      icon
      propertyOptions {
        name
        hasChildren
        legacyResourceId
        parentLegacyId
        propertyLegacyId
      }
      parent {
        ...BaseCategoryFields
        parent {
          ...BaseCategoryFields
        }
      }
      bundles {
        id
        count
        price
      }
      warningMessage
      isFreeLimitExceededForUser
      paidAdsBalance
    }
  }
`;

export const GET_CHILD_PROPERTY_OPTIONS = gql`
  query PropertyOptions(
    $legacyId: ID!
    $parentLegacyId: ID
    $includePhotos: Boolean = false
  ) {
    property(legacyId: $legacyId) {
      popularOptions(parentLegacyId: $parentLegacyId) {
        legacyResourceId
        name
        parentLegacyId
        propertyLegacyId
        childrenPropertyIds
        hasAutogeneratedTitle
        photos @include(if: $includePhotos) {
          id
          url
        }
      }
      options(parentLegacyId: $parentLegacyId) {
        legacyResourceId
        name
        parentLegacyId
        propertyLegacyId
        childrenPropertyIds
        hasAutogeneratedTitle
        photos @include(if: $includePhotos) {
          id
          url
        }
      }
    }
  }
`;

export const GET_PROPERTY_OPTION = gql`
  query PropertyOption($legacyId: ID!) {
    propertyOption(legacyId: $legacyId) {
      name
    }
  }
`;

export const GET_CATEGORY_ADS_COUNTER = gql`
  query CategoryAdsCounter(
    $path: String!
    $keywords: String
    $filters: AdFilterInput
  ) {
    category(path: $path, filters: $filters, keywords: $keywords) {
      count
    }
  }
`;
